module.exports = __webpack_public_path__ + "img/ic_map-inactive.1ca71a70.svg";